// ? When adding columns, remember to update model on the backend.
// ? especially the filterSchema.

import { dateOf } from '@/lib/time';

export default {
	columns : {
		actionRequestsKey : {
			title  : 'ID',
			sort   : 'number',
			filter : 'string',
			hidden : false,
			order  : 0,
		},

		number : {
			title        : 'Request #',
			sort         : 'number',
			filter       : 'string',
			hidden       : false,
			order        : 1,
			filterColumn : 'number'
		},

		dateRequested : {
			title         : 'Date',
			sort          : 'date',
			filter        : 'date',
			index         : true,
			hidden        : false,
			order         : 2,
			transformText : dateOf,
		},

		jobNumber : {
			title        : 'Job/Misc. Job #',
			sort         : 'number',
			filter       : 'string',
			hidden       : false,
			order        : 3,
			filterColumn : 'jobs.number',
		},

		facilities : {
			title         : 'Facility',
			sort          : 'string',
			filter        : 'string',
			hidden        : false,
			order         : 4,
			filterColumn  : 'facilities.[name,number]',
			key           : 'facilities',
			transformText : a => a.reduce( ( allFacilities, facility, index ) => {

				const formattedFacilityText = `${facility.name} No. ${facility.number}`;
				const facilityList          = `${allFacilities}${formattedFacilityText}`;

				if ( index === a.length - 1 ) {
					return facilityList;
				}

				return `${facilityList}<br>`;

			}, '' ),
		},

		requestingParty : {
			title  : 'Requesting Party',
			sort   : 'string',
			filter : 'string',
			index  : true,
			hidden : false,
			order  : 5,
		},

		fidContributions : {
			title  : 'FID Contribution',
			sort   : 'string',
			filter : 'string',
			index  : true,
			hidden : false,
			order  : 6,
		},

		locationDescription : {
			title        : 'Cross Streets',
			sort         : 'string',
			filter       : 'string',
			hidden       : false,
			order        : 7,
			filterColumn : 'location.description'
		},

		summary : {
			title  : 'Project Summary',
			sort   : 'string',
			filter : 'string',
			hidden : false,
			order  : 8,
		},

		rulingActionDescription : {
			title        : 'Ruling Action',
			sort         : 'string',
			filter       : 'string',
			hidden       : false,
			order        : 9,
			filterColumn : 'rulingAction.description',
		},

	},

	dropdownOptions : {}
};
